import React, { Component } from "react";
import { connect } from "react-redux";
import CustomCheckBox from "../ChartsOptionsSidebar/CustomCheckBox";
import * as d3 from "d3";
import "./MentionMap.scss";
import { downloadCSVData, downloadCanvasWithTitle } from "../utils";
import { drawMap } from "./chartUtils";

import _ from "lodash";
import CustomDropdown from "../ChartsOptionsSidebar/CustomDropdown";

import html2canvas from "html2canvas";
import { ReactComponent as MinusIcon } from "../../../../../assets/svg/minus-icon.svg";
import { ReactComponent as RefreshIcon } from "../../../../../assets/svg/refresh-map-icon.svg";
import { ReactComponent as PlusIcon } from "../../../../../assets/svg/plus-icon.svg";
import { ReactComponent as CloneIcon } from "../../../../../assets/svg/clone-icon.svg";
import { ReactComponent as Settings } from "../../../../../assets/svg/settings.svg";
import { ReactComponent as MoreOptions } from "../../../../../assets/svg/menu.svg";
import { showChartsDrilldown } from "../../../../../actions/dashboardAction";
import ChartOptionsSidebar from "../ChartsOptionsSidebar/ChartOptionsSidebar";
import DeleteWidget from "../ChartsOptionsSidebar/DeleteWidget";
import NoData from "../NoData/NoData";
import { ChartFilterIcon } from "../ChartFilterOptions";
import ChartName from "../ChartName";
import DownloadChart from "../DownloadChart";
import { ReactComponent as MiniMize } from "../../../../../assets/svg/zoom_in_map.svg";
import { ReactComponent as MaxiMize } from "../../../../../assets/svg/zoom_out_map.svg";
import Popup from "semantic-ui-react/dist/es/modules/Popup";

const countryOptions = [
    { key: "World", value: "World", label: "World" },
    { key: "Australia", value: "Australia", label: "Australia" },
    { key: "Bangladesh", value: "Bangladesh", label: "Bangladesh" },
    { key: "Brazil", value: "Brazil", label: "Brazil" },
    { key: "Brunei", value: "Brunei", label: "Brunei" },
    { key: "China", value: "China", label: "China" },
    { key: "Hong Kong", value: "Hong Kong", label: "Hong-Kong" },
    { key: "India", value: "India", label: "India" },
    { key: "Indonesia", value: "Indonesia", label: "Indonesia" },
    { key: "Japan", value: "Japan", label: "Japan" },
    { key: "Lebanon", value: "Lebanon", label: "Lebanon" },
    { key: "Malaysia", value: "Malaysia", label: "Malaysia" },
    { key: "Mexico", value: "Mexico", label: "Mexico" },
    { key: "Myanmar", value: "Myanmar", label: "Myanmar" },
    { key: "New Zealand", value: "New Zealand", label: "New Zealand" },
    { key: "Pakistan", value: "Pakistan", label: "Pakistan" },
    { key: "Philippines", value: "Philippines", label: "Philippines" },
    { key: "Singapore", value: "Singapore", label: "Singapore" },
    { key: "South Africa", value: "South Africa", label: "South Africa" },
    { key: "southkorea", value: "southkorea", label: "South-Korea" },
    { key: "Sri Lanka", value: "Sri Lanka", label: "Sri Lanka" },
    { key: "Taiwan", value: "Taiwan", label: "Taiwan" },
    { key: "Thailand", value: "Thailand", label: "Thailand" },
    { key: "Turkey", value: "Turkey", label: "Turkey" },
    { key: "Ukraine", value: "Ukraine", label: "Ukraine" },
    { key: "United Kingdom", value: "United Kingdom", label: "United Kingdom" },
    { key: "unitedstates", value: "unitedstates", label: "United States" },
    { key: "Vietnam", value: "Vietnam", label: "Vietnam" },
];

class MentionsMap extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showInfo: false,
            country: "World",
            downloading: false,
            previousScale: null,
            width: "100%",
            labelWidth: "30%",
            height: "100%",
            filteredCountries: this.filteredCountries(),
            data: this.props.data,
            showSubRegion: false,
        };
        this.measure = this.measure.bind(this);
        this.mapContainer = React.createRef();
    }

    getCountryData(country, data) {
        if (country.toLowerCase() == "world") {
            let regions_arr = [];
            data &&
                data.map((key) => {
                    let regions_obj = {
                        name: key.name,
                    };
                    let total = 0;
                    let negative = 0;
                    let neutral = 0;
                    let positive = 0;
                    key.regions.map((k) => {
                        total = total + k.total;
                        negative = negative + k.negative;
                        neutral = neutral + k.neutral;
                        positive = positive + k.positive;
                        k.country = key.name;
                        regions_arr.push(k);
                    });
                    regions_obj.total = key.total;
                    regions_obj.negative = negative;
                    regions_obj.neutral = neutral;
                    regions_obj.positive = positive;
                    let countryObj = this.props.locationsActive.find((elem) => elem.name && elem.name.toLowerCase() === key.name.toLowerCase());
                    if (countryObj) regions_arr.push(regions_obj);
                });
            let world_obj = {
                name: "world",
                regions: regions_arr,
            };
            return world_obj ? world_obj.regions : [];
        }
        if (country.toLowerCase() === "brunei") {
            country = "brunei darussalam";
        }
        if (country.toLowerCase() === "unitedstates") {
            country = "united states";
        }
        console.log("country......", country);
        console.log("data......", data);

        let countryData = data.find((x) => x.name.toLowerCase() === country.toLowerCase());
        return countryData ? countryData.regions : [];
    }

    getStateData(country, data) {
        if (country.toLowerCase() == "world") {
            let subregions_arr = [];
            data &&
                data.map((key) => {
                    let subregions_obj = {
                        name: key.name.toLowerCase(),
                    };
                    let total = 0;
                    let negative = 0;
                    let neutral = 0;
                    let positive = 0;
                    key.subregions &&
                        key.subregions.map((k) => {
                            total = total + k.total;
                            negative = negative + k.negative;
                            neutral = neutral + k.neutral;
                            positive = positive + k.positive;
                            k.country = key.name;
                            subregions_arr.push(k);
                        });
                    subregions_obj.total = key.total;
                    subregions_obj.negative = negative;
                    subregions_obj.neutral = neutral;
                    subregions_obj.positive = positive;
                    let countryObj = this.props.locationsActive.find((elem) => (elem.name && elem.name.toLowerCase()) === (key.name && key.name.toLowerCase()));
                    if (countryObj) subregions_arr.push(subregions_obj);
                });
            let world_obj = {
                name: "world",
                regions: subregions_arr,
            };
            return world_obj ? world_obj.regions : [];
        }
        if (country.toLowerCase() === "brunei") {
            country = "brunei darussalam";
        }
        if (country.toLowerCase() === "unitedstates") {
            country = "united states";
        }
        let countryData = data && data.find((x) => x.name.toLowerCase() === country.toLowerCase());

        return countryData ? countryData.subregions : [];
    }

    handleIntervalChange = (val) => {
        this.props.handleIntervalChange(val);
    };
    componentDidMount() {
        let data = this.props.data;
        let filteredData = [];
        data?.forEach((d) => {
            this.state.filteredCountries.forEach((c) => {
                if (c.value.toLowerCase() == d.name) filteredData.push(d);
                if (c.value == "unitedstates" && d.name == "united states") filteredData.push(d);
                if (c.value == "unitedstates" && d.name == "united states of america") filteredData.push(d);
            });
        });
        this.setState({ data: filteredData });
        let allCountries = JSON.parse(localStorage.getItem("filterOptions")).countries;

        if (this.state.data && this.state.data.length) this.measure();

        this.setState({ country: "World" });

        if (this.props.appliedFilter.countries && this.props.appliedFilter.countries.length == 1) {
            allCountries
                .filter((c) => countryOptions.find((o) => o.value == c.name))
                .map((c) => {
                    if (c.id == this.props.appliedFilter.countries[0]) {
                        this.setState({ country: c.name });
                    }
                });
        }
    }

    UNSAFE_componentWillMount() {
        window.addEventListener("resize", this.measure, false);
    }
    componentWillUnmount() {
        window.removeEventListener("resize", this.measure, false);
    }

    measure() {
        if (!this.mapContainer.current) return;
        let rect = this.mapContainer.current.getBoundingClientRect();

        this.drawMapFunction(rect.width - 12, rect.height - 60);
    }

    componentDidUpdate(prevProps) {
        if (this.props.resizedCount !== prevProps.resizedCount && this.state.data && this.state.data.length) {
            this.measure();
        }
        if (this.props.loading) {
            if (this.props.loading !== prevProps.loading) {
                const filteredCountries = this.filteredCountries();
                this.setState({
                    filteredCountries,
                    country: filteredCountries.length > 0 ? filteredCountries[0].key : "",
                    previousScale: null,
                    showSubRegion: false,
                });
            }
        } else if (this.state.data && this.state.data.length) {
            this.measure();
        }
        if (prevProps.appliedFilter !== this.props.appliedFilter) {
            this.setState({ showSubRegion: false });
        }
    }

    drawMapFunction = (width, height) => {
        if (this.state.data && !this.props.loading && this.mapEl) {
            drawMap.call(
                this,
                this.mapEl,
                this.state.country,
                this.getCountryData(this.state.country, this.state.data),
                (d, countryObject) => this.handleContextMenuClick(d, countryObject),
                (d, countryObject) => this.handleDrilldownClick(d, countryObject),
                this.getLegendsData(),
                this.state.downloading || this.props.btnText === "Downloading.....",
                this.handleCountryChange.bind(this),
                this.props.locationsActive,
                null,
                this.state.previousScale,
                (p) => this.handleZoomChange(p),
                this.getStateData(this.state.country, this.props.stateData && this.props.stateData),
                this.state.showSubRegion,
                { width, height },
                this.props.isPublic,
                // (bool, name) => this.props.showChartsDrilldown(bool, name),
            );
        } else {
            return <NoData message="There is no data for the selected filters." />;
        }
        if (this.props.stateData && this.state.showSubRegion && this.state.country !== "World") {
            drawMap.call(
                this,
                this.mapEl,
                `${this.state.country}subregions`,
                this.getStateData(this.state.country, this.props.stateData),
                (d, countryObject) => this.handleContextMenuClick(d, countryObject),
                (d, countryObject) => this.handleDrilldownClick(d, countryObject),
                this.getLegendsData(),
                this.state.downloading || this.props.btnText === "Downloading.....",
                this.handleCountryChange.bind(this),
                this.props.locationsActive,
                null,
                this.state.previousScale,
                (p) => this.handleZoomChange(p),
                this.getStateData(this.state.country, this.props.stateData),
                this.state.showSubRegion,
                { width, height },
                this.props.isPublic,
                // (bool, name) => this.props.showChartsDrilldown(bool, name),
            );
        } else {
            return <NoData message="There is no data for the selected filters." />;
        }
    };

    shouldComponentUpdate(nextProps, nextState) {
        if (
            this.state.previousScale !== nextState.previousScale ||
            (this.state.previousScale &&
                nextState.previousScale &&
                this.state.previousScale[0] !== nextState.previousScale[0] &&
                this.state.previousScale[1] !== nextState.previousScale[1])
        ) {
            return false;
        } else return true;
    }

    handleZoomChange = (previousScale) => {
        this.setState({ previousScale });
    };

    handleCountryChange = (val) => {
        this.setState({ showSubRegion: false });

        if (val.toLowerCase() === "united states" || val.toLowerCase() === "united states of america") {
            val = "unitedstates";
        }

        let even = function (obj) {
            return obj.value === val;
        };

        if (!countryOptions.some(even)) {
            return;
        }
        if (this.state.country !== val) {
            this.setState({
                previousScale: null,
            });
            this.setState(
                {
                    country: val,
                },
                () => this.measure(),
            );
        }
    };

    filteredCountries = () => {
        if (!this.props.appliedFilter || (this.props.appliedFilter && !this.props.appliedFilter.countries)) return countryOptions;
        if (this.props.appliedFilter.countries[0] === "selectAll" || this.props.appliedFilter.countries.length === 0) {
            let allOptions = this.props.locationsActive.map((y) => y.name);
            let countriesDropDown = [];
            countryOptions.forEach((elem) => {
                if (
                    allOptions.includes(elem.key) ||
                    (elem.key === "southkorea" && allOptions.includes("South Korea")) ||
                    (elem.key === "unitedstates" && allOptions.includes("United States")) ||
                    (elem.key === "New Zealand" && allOptions.includes("New zealand")) ||
                    (elem.key === "Brunei" && allOptions.includes("Brunei Darussalam"))
                ) {
                    countriesDropDown.push(elem);
                }
            });
            countriesDropDown.unshift({ key: "World", value: "World", label: "World" });
            return countriesDropDown;
        }
        let selectedCountries = this.props.appliedFilter.countries.map((x) => this.props.locationsActive.find((y) => y.id === x)).map((x) => x.name);
        if (selectedCountries.includes("United States")) {
            selectedCountries[selectedCountries.indexOf("United States")] = "unitedstates";
        }
        return countryOptions.filter((x) => selectedCountries.includes(x.key) || x.key == "World");
    };

    createNewFilter(d, countryObject) {
        let newFilter = this.props.filters ? JSON.parse(JSON.stringify(this.props.filters)) : {};

        if (countryObject) {
            newFilter.post_address_country = countryObject.name.toLowerCase();
        } else {
            if (this.state.showSubRegion) {
                if (d.properties.NAME_2) var subregion = d.properties.NAME_2;
                newFilter.extras = [
                    { key: "sub_region", value: subregion },
                    { key: "lat_long_exact", value: "yes" },
                ];
            } else {
                let region = d.properties.NAME_1.toLowerCase();
                if (region === "jammu & kashmir") region = "kashmir";
                newFilter.extras = [{ key: "region", value: region }];
            }
        }
        return newFilter;
    }

    handleContextMenuClick(d, countryObject) {
        let newFilter = this.createNewFilter(d, countryObject);

        this.props.handleContextMenuClick(newFilter);
    }

    handleDrilldownClick(d, countryObject) {
        let newFilter = this.createNewFilter(d, countryObject);

        this.props.handleDrilldownClick(newFilter);
    }

    downloadCSV = () => {
        if (this.props.isFreeTierPackage) {
            this.props.packageUpgradePopup();
            return;
        }
        let csvData = this.getCountryData(this.state.country, this.state.data).map((x) => [x.name, x.total, x.positive, x.neutral, x.negative]);
        if (this.state.showSubRegion)
            csvData = this.getStateData(this.state.country, this.props.stateData).map((x) => [
                this.formatName(x.name),
                x.total,
                x.positive,
                x.neutral,
                x.negative,
            ]);
        csvData.unshift(["Name", "Mentions", "Positive", "Neutral", "Negative"]);
        downloadCSVData(csvData, this.props.widget.name);
    };

    formatName(name) {
        let fname = name.replaceAll("ā", "a");
        fname = fname.replaceAll("Ā", "A");
        fname = fname.replaceAll("ī", "i");
        fname = fname.replaceAll("Ī", "I");
        fname = fname.replaceAll("ē", "e");
        fname = fname.replaceAll("Ē", "E");
        fname = fname.replaceAll("ō", "o");
        fname = fname.replaceAll("Ō", "O");
        fname = fname.replaceAll("ū", "u");
        fname = fname.replaceAll("Ū", "U");
        return fname;
    }

    getLegendsData() {
        let regions = this.getCountryData(this.state.country, this.state.data);
        let subregions = this.getStateData(this.state.country, this.props.stateData);
        let n = 5;
        if (regions.length === 0) return [];
        let mentions = regions.map((x) => x.total);
        if (this.state.showSubRegion) mentions = subregions.map((x) => x.total);
        let max = d3.max(mentions);
        let min = d3.min(mentions);

        let colors = ["#FFBB44", "#FFA63C", "#FF9135", "#FF7D2D", "#FF6826", "#FF531E", "#FF3E17", "#FF2A0F", "#FF1508", "#FF0000"];

        if (max === min) return [{ from: 0, to: max, color: colors[0] }];

        let interval = Math.pow(10, parseInt(Math.log(max - min) / Math.log(10)));
        min = parseInt(min / interval) * interval;
        max = (parseInt(max / interval) + 1) * interval;

        let totalNums = (max - min) / interval;

        let colorScale = d3.scale.linear().domain([0, totalNums]).range([0, 9]);

        let ranges = [];
        let i = 0;
        <div></div>;
        while (min < max) {
            ranges.push({ from: min, to: min + interval, color: colors[parseInt(colorScale(i))] });
            min += interval;
            i++;
        }
        return ranges;
    }

    downloadPNG = (cb, options) => {
        if (this.props.isFreeTierPackage) {
            this.props.packageUpgradePopup();
            return;
        }
        html2canvas(this.mapContainer.current, { backgroundColor: options.background ? "#fff" : null, allowTaint: true, useCORS: true }).then((canvas) => {
            cb && cb();
            downloadCanvasWithTitle(canvas, this.props.widget.name);
        });
    };

    renderDownloadButton(nodata) {
        return (
            <DownloadChart
                nodata={nodata}
                options={[
                    { name: "CSV", downloadFn: this.downloadCSV },
                    {
                        name: "PNG",
                        downloadFn: this.downloadPNG,
                        showLoader: true,
                        background: true,
                    },
                    {
                        name: "PNG(Transparent)",
                        downloadFn: this.downloadPNG,
                        showLoader: true,
                        background: false,
                    },
                ]}
            />
        );
    }

    nodata = () => {
        return !this.state.data || (this.state.data && this.state.data.length === 0) || this.props.noTopicsSelected;
    };

    render() {
        let i = -1;

        let nodata = this.nodata();

        return (
            <>
                <div className="dashboard-widget-container-header skiptranslate">
                    <ChartName
                        name={this.props.widget.name}
                        info="Please note that the mentions depicted in the graph are only displayed for posts where exact latitude and longitude information is available."
                    />
                    <div className="dashboard-widget-actions" data-html2canvas-ignore="true">
                        {!this.props.isPublic &&
                            !this.props.isResearchDashboard &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && (
                                <ChartFilterIcon
                                    chartFilterApplied={this.props.chartFilterApplied}
                                    changeShowChartFilterOptions={this.props.changeChartFilter}
                                    widgetListDashboardCurrent={this.props.widgetListDashboardCurrent}
                                    name={this.props.widget.name}
                                />
                            )}
                        {!this.props.isPublic && !this.props.isResearchDashboard && this.renderDownloadButton(nodata)}

                        {
                            <>
                                {this.props.isPublic && nodata ? null : (
                                    <Popup
                                        className="skiptranslate"
                                        trigger={
                                            this.props.expandWidget ? (
                                                <MiniMize className="chart-header-icon" onClick={this.props.expandFullWidget} />
                                            ) : (
                                                <MaxiMize className="chart-header-icon" onClick={this.props.expandFullWidget} />
                                            )
                                        }
                                        inverted
                                        content={this.props.expandWidget ? "Minimize Widget" : "Maximize Widget"}
                                        size="mini"
                                        position="bottom center"
                                        style={{ zIndex: "99999" }}
                                    />
                                )}
                            </>
                        }
                        {this.props.isPublic && nodata ? null : <MoreOptions className="more-options" onClick={(e) => this.props.changeShowMoreOptions(e)} />}
                    </div>
                </div>
                {this.props.showMoreOptions && (
                    <ChartOptionsSidebar
                        data-html2canvas-ignore="true"
                        showMoreOptionsLoc={this.props.showMoreOptionsLoc}
                        changeShowMoreOptions={this.props.changeShowMoreOptions}>
                        {!nodata && (this.state.country == "India" || this.state.country == "Indonesia") && (
                            <CustomCheckBox
                                label="Show Sub Regions"
                                onClick={() => this.setState({ showSubRegion: !this.state.showSubRegion })}
                                checked={this.state.showSubRegion}
                                style={{ marginLeft: "10px" }}
                            />
                        )}
                        {!nodata && (
                            <CustomDropdown
                                className="leaderboard-sort-by"
                                name="Select Country"
                                isSearchable={true}
                                options={this.state.filteredCountries}
                                // options={selectedCountries && countryOptions.filter((c) => selectedCountries.includes(c.value))}
                                value={this.state.country}
                                onChange={this.handleCountryChange}
                            />
                        )}
                        {!this.props.isPublic &&
                            !this.props.isStandardDashboard &&
                            !this.props.isResearchDashboard &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && (
                                <>
                                    <div className="chart-settings menu-option" onClick={this.props.chartSettings}>
                                        <span>Chart Configuration</span>
                                        <Settings />
                                    </div>
                                    <div className="clone-chart menu-option" onClick={this.props.cloneWidget}>
                                        <span>Clone Chart</span>
                                        <CloneIcon />
                                    </div>
                                </>
                            )}
                        {!this.props.isPublic &&
                            !this.props.isStandardDashboard &&
                            !this.props.isResearchDashboard &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && <DeleteWidget onClick={this.props.deleteWidget} />}
                    </ChartOptionsSidebar>
                )}
                {!nodata ? (
                    <div className="dashboard-chart skiptranslate mention-map-wrapper" ref={this.mapContainer}>
                        <div id="mapEL" ref={(el) => (this.mapEl = el)}></div>

                        <div className="mention-map-legends" data-html2canvas-ignore="true">
                            {(this.state.country == "World" || this.state.showSubRegion) && (
                                <div className="button-wrapper">
                                    <PlusIcon id="zoom-in" className="zoom-out" />
                                    <MinusIcon id="zoom-out" className="zoom-out" />
                                    <RefreshIcon id="reset" className="zoom-out" />
                                </div>
                            )}
                        </div>
                        <div className="legend-wrapper">
                            {this.state.data &&
                                this.getLegendsData().map((legend) => {
                                    i++;
                                    return (
                                        <div key={i} className="mention-map-legend-item">
                                            <div
                                                className="square"
                                                style={{
                                                    backgroundColor: legend.color,
                                                    width: 8,
                                                    height: 8,
                                                    borderRadius: 8,
                                                    marginRight: 8,
                                                    marginLeft: 2,
                                                }}></div>
                                            <span className="range">
                                                {" "}
                                                {legend.from} - {legend.to}{" "}
                                            </span>
                                        </div>
                                    );
                                })}
                        </div>
                    </div>
                ) : (
                    <NoData
                        message={
                            !this.props.isPublic && this.props.noTopicsSelected
                                ? "To view charts, please select topics using either the page filters on the left or the chart filters on this chart."
                                : null
                        }
                    />
                )}
            </>
        );
    }
}

function mapStateToProps(state) {
    return {
        locationsActive: state.filterSettingReducer.locationsActive,
        filterOptions: state.globalReducer.filterOptions,
        widgetListDashboardCurrent: state.dashboardReducer.widgetListDashboardCurrent,
        maximizeWidgetValue: state.dashboardReducer.maximizeWidgetValue,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        showChartsDrilldown: (bool, name) => dispatch(showChartsDrilldown(bool, name)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(MentionsMap);
